import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function ImageEditingIcon(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 20 20" {...props}>
			<rect x="0.175768" y="0.175768" width="19.6485" height="19.6485" rx="3.82423" fill="#BA99E9" />
			<rect
				x="0.175768"
				y="0.175768"
				width="19.6485"
				height="19.6485"
				rx="3.82423"
				stroke="#E7E7E7"
				strokeWidth="0.351536"
				fill="#BA99E9"
			/>
			<path
				d="M11.875 7.5H11.8813M9.375 15H6.875C6.37772 15 5.90081 14.8025 5.54917 14.4508C5.19754 14.0992 5 13.6223 5 13.125V6.875C5 6.37772 5.19754 5.90081 5.54917 5.54917C5.90081 5.19754 6.37772 5 6.875 5H13.125C13.6223 5 14.0992 5.19754 14.4508 5.54917C14.8025 5.90081 15 6.37772 15 6.875V9.375M5 11.875L7.5 9.37501C8.08 8.81688 8.795 8.81688 9.375 9.37501L11.25 11.25L11.875 10.625C12.0688 10.4387 12.2775 10.3144 12.4919 10.2525M14.0125 12.2562C14.1344 12.1344 14.2791 12.0377 14.4383 11.9717C14.5976 11.9057 14.7683 11.8718 14.9406 11.8718C15.113 11.8718 15.2837 11.9057 15.4429 11.9717C15.6022 12.0377 15.7469 12.1344 15.8687 12.2562C15.9906 12.3781 16.0873 12.5228 16.1533 12.6821C16.2192 12.8413 16.2532 13.012 16.2532 13.1844C16.2532 13.3567 16.2192 13.5274 16.1533 13.6867C16.0873 13.8459 15.9906 13.9906 15.8687 14.1125L13.75 16.25H11.875V14.375L14.0125 12.2562Z"
				stroke="white"
				strokeWidth="0.78125"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="#BA99E9"
			/>
		</SvgIcon>
	);
}

export default ImageEditingIcon;
